import { graphql } from "react-relay";

export const QUERY = graphql`
	query messageDispatches_MessageDispatchesQuery {
		...messageDispatchesTable_QueryFragment
	}
`;
